module.exports = __webpack_public_path__ + "img/icon-live-active.07040dd.webp";